import FlightInfo from './components/FlightInfo/FlightInfo';
import LoginInput from './components/LoginInput/LoginInput';
import Payment from './components/Payment/Payment';
import { southwindEquipmentIcons } from './components/HeaderEquipmentItem/icons';
import CalendarDay from './components/CalendarDay/CalendarDay';
import CheckoutServicesV2 from '@websky/core/src/Checkout/components/Checkout/ServicesV2/ServicesV2';
import CheckinServicesV2 from '@websky/core/src/Modules/Checkin/components/Checkin/AdditionalServices/AdditionalServices';
export const renders = {
    /* Override React components */
    renderFlightInfo: FlightInfo,
    LoginInput,
    CheckoutPayment: Payment,
    CalendarDay: CalendarDay,
    renderHeaderEquipmentIcon: rfisc => southwindEquipmentIcons === null || southwindEquipmentIcons === void 0 ? void 0 : southwindEquipmentIcons[rfisc],
    CheckoutServices: CheckoutServicesV2,
    CheckinServices: CheckinServicesV2
};
